import React, { FunctionComponent } from "react";

import { bemClassNames } from "@multiweb/reactUtils";
import { ComponentTheme } from "@multiweb/uiShared/ComponentTheme";

export type DividerProps = {
    /** Téma oddělovače */
    theme?: ComponentTheme;
};

const classNames = bemClassNames("divider-component");

/** Komponenta slouží jako vertikální vizuální oddělovač. */
export const Divider: FunctionComponent<DividerProps> = ({
    theme = ComponentTheme.default,
}) => (
    <div className={classNames({ theme })} />
);
